import { Controller } from "@hotwired/stimulus"
import { DateTime } from "luxon"

export default class extends Controller {
  static targets = ["date", "time", "submit", "sendNow"]
  static values = {
    timezone: String
  }

  connect() {
    this.validate()
  }

  validate() {
    if (this.sendNowTarget.checked) {
      this.enableSubmit()
      this.clearValidationErrors()
      return
    }

    const dateField = this.dateTarget
    const timeField = this.timeTarget

    if (!dateField.value || !timeField.value) {
      this.disableSubmit()
      return
    }

    const selectedDateTime = `${dateField.value} ${timeField.value}`
    const selectedDate = DateTime.fromFormat(
      selectedDateTime,
      'yyyy-MM-dd HH:mm',
      { zone: this.timezoneValue }
    )

    const now = DateTime.now().setZone(this.timezoneValue)
    const minDate = now.plus({ minutes: 5 })

    if (selectedDate <= minDate) {
      dateField.setCustomValidity(window.I18n.notifications.datetime_must_be_in_the_future)
      timeField.setCustomValidity(window.I18n.notifications.datetime_must_be_in_the_future)
      this.disableSubmit()
    } else {
      this.clearValidationErrors()
      this.enableSubmit()
    }

    dateField.reportValidity()
    timeField.reportValidity()
  }

  clearValidationErrors() {
    this.dateTarget.setCustomValidity("")
    this.timeTarget.setCustomValidity("")
  }

  disableSubmit() {
    this.submitTarget.disabled = true
  }

  enableSubmit() {
    this.submitTarget.disabled = false
  }
}
